import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

// Heroicons outline "user-!" - a person silhouette with a warning triangle, Figma's icon for the
// "Unable to remove team member(s)" error dialog (someone is an authoriser/has a pending action).
const UserExclamation = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ size, variant, className }))}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none">
    <path
      d="M25.5 12.75C25.5 16.4779 22.4779 19.5 18.75 19.5C15.0221 19.5 12 16.4779 12 12.75C12 9.02208 15.0221 6 18.75 6C22.4779 6 25.5 9.02208 25.5 12.75Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.05913"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.00184 38.4686C6.00062 38.3959 6 38.323 6 38.25C6 31.2084 11.7084 25.5 18.75 25.5C25.7916 25.5 31.5 31.2084 31.5 38.25V38.2551C31.5 38.3264 31.4994 38.3976 31.4982 38.4686C27.7747 40.7105 23.4129 42 18.75 42C14.0871 42 9.72528 40.7105 6.00184 38.4686Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.05913"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.4485 12.8821C38.1381 11.6877 39.8619 11.6878 40.5515 12.8821L46.7573 23.6309C47.4469 24.8252 46.5849 26.3181 45.2059 26.3181H32.7941C31.4151 26.3181 30.5531 24.8252 31.2427 23.6309L37.4485 12.8821ZM39 14.9721C39.4947 14.9721 39.8957 15.3732 39.8957 15.8679V19.4508C39.8957 19.9455 39.4947 20.3465 39 20.3465C38.5053 20.3465 38.1043 19.9455 38.1043 19.4508V15.8679C38.1043 15.3732 38.5053 14.9721 39 14.9721ZM39 24.5267C39.6596 24.5267 40.1943 23.9919 40.1943 23.3323C40.1943 22.6727 39.6596 22.138 39 22.138C38.3404 22.138 37.8057 22.6727 37.8057 23.3323C37.8057 23.9919 38.3404 24.5267 39 24.5267Z"
      fill="currentColor"
    />
  </svg>
);

export default UserExclamation;
